import React, { Fragment } from 'react';
import IntlMessages from 'util/IntlMessages';
import BasicDetailRow from 'components/basicDetailRow';

const ValueStreamDetailTable = ({ displayData }) => {
    if (displayData) {
        return (
            <table className="default-table table table-sm table-responsive-sm table-hover">
                <tbody>
                    <BasicDetailRow label={<IntlMessages id="label.description" />} description={displayData?.description} />
                    <BasicDetailRow label={<IntlMessages id="label.portfolio" />} description={displayData?.portfolio} />
                    <BasicDetailRow label={<IntlMessages id="label.valueProposition" />} description={displayData?.valueProposition} />
                    <BasicDetailRow label={<IntlMessages id="label.budget" />} description={displayData?.budget} />
                    <BasicDetailRow label={<IntlMessages id="label.kpi" />} description={displayData?.kpi} />
                    <BasicDetailRow label={<IntlMessages id="label.systems" />} description={displayData?.systems} />
                    <BasicDetailRow label={<IntlMessages id="label.owner" />} description={displayData?.owner} />
                    <BasicDetailRow label={<IntlMessages id="label.theme" />} description={displayData?.theme} />
                    
                </tbody>
            </table>
        );
    } else {
        return <Fragment></Fragment>;
    }
};

export default ValueStreamDetailTable;


// WEBPACK FOOTER //
// ./components/Agile/valueStream/valueStreamDetail/valueStreamDetailTable/index.js